import React from 'react'
import styled from 'styled-components'
import { MdBlock } from 'react-icons/md'
import { FaChrome, FaFirefox, FaEdge } from 'react-icons/fa'
import { MobergFontFamily } from '../MobergFont/MobergFont'

const SafariUnsupportedModal = () => {
    return (
        <ModalContainer>
            <HeaderSection>
                <IconWrapper>
                    <MdBlock size={64} />
                </IconWrapper>
                <ModalTitle>
                    Safari Not Supported
                </ModalTitle>
                <ModalSubtitle>
                    Please switch to a supported browser
                </ModalSubtitle>
            </HeaderSection>

            <ContentSection>
                <ModalMessage>
                    The Moberg Platform requires a supported browser for optimal performance and security. Safari is currently not supported.
                </ModalMessage>

                <BrowserGrid>
                    <BrowserCard>
                        <BrowserIcon>
                            <FaChrome size={32} />
                        </BrowserIcon>
                        <BrowserName>Chrome</BrowserName>
                        <BrowserStatus>Recommended</BrowserStatus>
                    </BrowserCard>

                    <BrowserCard>
                        <BrowserIcon>
                            <FaEdge size={32} />
                        </BrowserIcon>
                        <BrowserName>Edge</BrowserName>
                        <BrowserStatus>Supported</BrowserStatus>
                    </BrowserCard>

                    <BrowserCard>
                        <BrowserIcon>
                            <FaFirefox size={32} />
                        </BrowserIcon>
                        <BrowserName>Firefox</BrowserName>
                        <BrowserStatus>Supported</BrowserStatus>
                    </BrowserCard>
                </BrowserGrid>

            </ContentSection>
        </ModalContainer>
    )
}

const ModalContainer = styled.div`
    text-align: center;
    padding: 0;
    width: 520px;
    background: #ffffff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.12);
`

const HeaderSection = styled.div`
    background: #ffffff;
    padding: 40px 32px 32px;
    position: relative;
    border-bottom: 1px solid #e5e7eb;
`

const IconWrapper = styled.div`
    margin-bottom: 16px;
    color: #dc2626;
`

const ModalTitle = styled.h3`
    font-family: ${MobergFontFamily.HEADER};
    font-size: 24px;
    font-weight: 600;
    color: #1f2937;
    margin: 0 0 8px 0;
`

const ModalSubtitle = styled.p`
    font-family: ${MobergFontFamily.REGULAR};
    font-size: 16px;
    color: #6b7280;
    margin: 0;
    font-weight: 400;
`

const ContentSection = styled.div`
    padding: 32px;
`

const ModalMessage = styled.p`
    font-family: ${MobergFontFamily.REGULAR};
    font-size: 16px;
    color: #4b5563;
    line-height: 1.6;
    margin: 0 0 32px 0;
    max-width: 440px;
    margin-left: auto;
    margin-right: auto;
`

const BrowserGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px;
    margin-bottom: 24px;
`

const BrowserCard = styled.div`
    background: #f8fafc;
    border: 2px solid #e2e8f0;
    border-radius: 8px;
    padding: 24px 16px;
    cursor: default;
    display: flex;
    flex-direction: column;
    align-items: center;
`

const BrowserIcon = styled.div`
    margin-bottom: 12px;
    color: #374151;

    ${BrowserCard}:nth-child(1) & {
        color: #4285f4;
    }

    ${BrowserCard}:nth-child(2) & {
        color: #0078d7;
    }

    ${BrowserCard}:nth-child(3) & {
        color: #ff7139;
    }
`

const BrowserName = styled.h3`
    font-family: ${MobergFontFamily.HEADER};
    font-size: 24px;
    font-weight: 600;
    color: #1f2937;
    margin: 0 0 4px 0;
`

const BrowserStatus = styled.span`
    display: inline-block;
    font-family: ${MobergFontFamily.REGULAR};
    color: #6b7280;
    background: #e5e7eb;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    white-space: nowrap;

    ${BrowserCard}:nth-child(1) & {
        color: #059669;
        background: #d1fae5;
    }
`


export default SafariUnsupportedModal